import React, { Component } from 'react';

// Externals
import classNames from 'classnames';
import compose from 'recompose/compose';

// Material helpers
import { withStyles } from '@material-ui/core/styles';

import { withRouter } from 'react-router-dom';
// Shared components
import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletToolbar from 'components/PortletToolbar';
// Material components
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

// Custom components
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Popover from '@material-ui/core/Popover';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';

// Component styles
import styles from './styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import ScreenshotElement from './ScreenshotElement'
import Period from '../../../../helpers/PeriodScreenshot';
import Grid from '@material-ui/core/Grid';
import moment from 'moment-timezone'
import 'moment/locale/es'
moment.locale('es')



class ScreenshotsRebuild extends Component {
    constructor(props) {
        super(props);
        var nodes=(props.location.state.fromObjective.Nodos)
        var listNodes=[]                                                                                            
        nodes.map(node=>{
            if(node["nodo"]!=='Global'){
                listNodes.push(node)
            }
        })
        var statePeriod={}
        var endDate=(moment().tz(sessionStorage.getItem('tz')).format("YYYY-MM-DD hh:mm:ss"))
        var startDate=(moment().tz(sessionStorage.getItem('tz')).subtract(1,'day').format("YYYY-MM-DD hh:mm:ss"))
        statePeriod={startDate: startDate,endDate: endDate,key: "selection"}
        this.myCallback = this.myCallback.bind(this);
        var monitores=(props.location.state.fromObjective.Monitores)
        this.handlePeriodClick = this.handlePeriodClick.bind(this);
        this.state = {
            objetive: this.props.match.params.objetivo_id,
            isStatePeriod: false,
            settingsEl: null,
            steps:this.props.location.state.fromObjective.Pasos,
            isRefresh: false,
            isInfo: null,
            nodes:listNodes,
            listMonitores:monitores,
            dateMoment:((moment().locale('es'))),
            dateBefore:moment().subtract({'hours': 1}).locale('es'),
            limit:moment().subtract({'days': 6}).locale('es'),
            limit2:((moment().locale('es'))),
            errors:["","Solo puede seleccionar un día", "Ambas fechas no pueden ser iguales","Fecha inicial no puede ser mayor a Fecha Final", 
                    "Fecha Termino no puede superar fecha actual", "Rango debe ser de una Hora"],
            indexError:0,
            isLoad:false,
            extendEl: null,
            nameNodo: "Todos los Isp",
            node: 0,
            begin: (moment().tz(sessionStorage.getItem('tz')).subtract(1,'hour').format("YYYY-MM-DD HH:mm:ss")),
            end: (moment().tz(sessionStorage.getItem('tz')).format("YYYY-MM-DD HH:mm:ss")),
            isLoadButton:false,
            modal:false,
            //period: this.props.period,
            period: 'h',
            namePeriod: 'Rango: última hora',
            isStatePeriod: false,
            periodEl: null,
            namePeriodPorlet: ['Última Hora', 'Último Día', 'Última Semana', 'Custom', 'Últimas 3 Horas', 'Últimos 3 Días', 'Últimas 6 Horas', 'Últimas 12 Horas'],
            //typePeriod: this.props.typePeriod,
            typePeriod: 0,
            isOneHour: true,
            periodical: false,
            //typeGraph: this.props.typeGrap,
            typeGraph: 0,
            statePeriod: statePeriod,
            pages: 1,
            page: 0,
            service: this.props.location.state.fromObjective.servicio_id
        };
    }

    myCallback = (dataFromChild) => {
        this.setState({
            isLoadButton:false,
        })
    }

    changeDate=()=>{
        const {dateBefore, dateMoment, indexError}=this.state
        //console.log(dateBefore.format("YYYY-MM-DD H:mm:ss"), this.state.begin.format("YYYY-MM-DD H:mm:ss"))
        if(indexError===0&&(dateBefore.format("YYYY-MM-DD H:mm:ss")!==this.state.begin.format("YYYY-MM-DD H:mm:ss")||
            dateMoment.format("YYYY-MM-DD H:mm:ss")!==this.state.end.format("YYYY-MM-DD H:mm:ss"))){
            this.setState({
                begin:dateBefore,
                end:dateMoment,
                isLoadButton:true,
                modal:false,
            })
        }
    }

    handleNextNodeClick = event => {
        const nameNodo = event.currentTarget.name
        const newNode = event.currentTarget.id
        if (this.state.node !== newNode) {
            this.setState({
                //typeGraph: prevTypeGraph,
                //period: prevPeriod,
                node: newNode,
                isLastEvent: false,
                extendEl: null,
                isRefresh: false,
                nameNodo: nameNodo,
            })
        }
    }

    handleShowExtend = event => {
        this.setState({
            extendEl: event.currentTarget
        });
    };
    handleCloseExtend = () => {
        this.setState({
            extendEl: null
        });
    };

    handleClose = event => {
        //console.log('fsd')
        this.props.onClose()
    };
    
    
    handleShowPeriod = event => {
        this.setState({
            periodEl: event.currentTarget
        });
    };

    handleClosePeriod = () => {
        this.setState({
            periodEl: null
        });
    };

    handlePeriodClick(prevPeriod, prevTypeGraph, statePeriod, nextPeriod) {
        if (nextPeriod === 'hora') {
            var endDate=(moment().tz(sessionStorage.getItem('tz')).format("YYYY-MM-DD HH:mm:ss"))
            var startDate=(moment().tz(sessionStorage.getItem('tz')).subtract(1,'hour').format("YYYY-MM-DD HH:mm:ss"))
            statePeriod={startDate: startDate,endDate: endDate,key: "selection"}
            this.setState({
                //typeGraph: prevTypeGraph,
                period: 'h',
                typePeriod: 0,
                namePeriod: 'Rango: última hora',
                statePeriod: statePeriod,
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false,
                begin: startDate,
                end: endDate,
            });
        } else if (nextPeriod === '3hora') {
            var endDate=(moment().tz(sessionStorage.getItem('tz')).format("YYYY-MM-DD HH:mm:ss"))
            var startDate=(moment().tz(sessionStorage.getItem('tz')).subtract(3,'hour').format("YYYY-MM-DD HH:mm:ss"))
            statePeriod={startDate: startDate,endDate: endDate,key: "selection"}
            this.setState({
                //typeGraph: prevTypeGraph,
                period: '3h',
                typePeriod: 4,
                namePeriod: 'Rango: últimas 3 horas',
                statePeriod: statePeriod,
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false,
                begin: startDate,
                end: endDate,
            });
        }else if (nextPeriod === '6hora') {
            var endDate=(moment().tz(sessionStorage.getItem('tz')).format("YYYY-MM-DD HH:mm:ss"))
            var startDate=(moment().tz(sessionStorage.getItem('tz')).subtract(6,'hour').format("YYYY-MM-DD HH:mm:ss"))
            statePeriod={startDate: startDate,endDate: endDate,key: "selection"}
            this.setState({
                //typeGraph: prevTypeGraph,
                period: '6h',
                typePeriod: 6,
                namePeriod: 'Rango: últimas 6 horas',
                statePeriod: statePeriod,
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false,
                begin: startDate,
                end: endDate,
            });
        }else if (nextPeriod === '12hora') {
            var endDate=(moment().tz(sessionStorage.getItem('tz')).format("YYYY-MM-DD HH:mm:ss"))
            var startDate=(moment().tz(sessionStorage.getItem('tz')).subtract(12,'hour').format("YYYY-MM-DD HH:mm:ss"))
            statePeriod={startDate: startDate,endDate: endDate,key: "selection"}
            this.setState({
                //typeGraph: prevTypeGraph,
                period: '12h',
                typePeriod: 7,
                namePeriod: 'Rango: últimas 12 horas',
                statePeriod: statePeriod,
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false,
                begin: startDate,
                end: endDate,
            });
        } else if (nextPeriod === 'dia') {
            var endDate=(moment().tz(sessionStorage.getItem('tz')).format("YYYY-MM-DD HH:mm:ss"))
            var startDate=(moment().tz(sessionStorage.getItem('tz')).subtract(1,'day').format("YYYY-MM-DD HH:mm:ss"))
            statePeriod={startDate: startDate,endDate: endDate,key: "selection"}
            this.setState({
                //typeGraph: prevTypeGraph,
                period: "d",
                typePeriod: 1,
                namePeriod: 'Rango: último día',
                statePeriod: statePeriod,
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false,
                begin: startDate,
                end: endDate,
            });
        } /*else if (nextPeriod === '3dia') {
            var endDate=(moment().tz(sessionStorage.getItem('tz')).format("YYYY-MM-DD HH:mm:ss"))
            var startDate=(moment().tz(sessionStorage.getItem('tz')).subtract(3,'day').format("YYYY-MM-DD HH:mm:ss"))
            statePeriod={startDate: startDate,endDate: endDate,key: "selection"}
            this.setState({
                //typeGraph: prevTypeGraph,
                period: "3d",
                typePeriod: 5,
                namePeriod: 'Rango: últimos 3 días',
                statePeriod: statePeriod,
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false,
                begin: startDate,
                end: endDate,
            });
        } else if (nextPeriod === 'semana') {
            var endDate=(moment().tz(sessionStorage.getItem('tz')).format("YYYY-MM-DD HH:mm:ss"))
            var startDate=(moment().tz(sessionStorage.getItem('tz')).subtract(1,'week').format("YYYY-MM-DD HH:mm:ss"))
            statePeriod={startDate: startDate,endDate: endDate,key: "selection"}
            this.setState({
                //typeGraph: prevTypeGraph,
                period: "w",
                typePeriod: 2,
                namePeriod: 'Rango: última semana',
                statePeriod: statePeriod,
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false,
                begin: startDate,
                end: endDate,
            });
        }*/ else if (nextPeriod === 'custom') {
            var startDate = moment(statePeriod).format("YYYY-MM-DD HH:mm:ss")
            var endDate = moment(statePeriod).add('days', 1).format("YYYY-MM-DD HH:mm:ss")
            statePeriod = {startDate: startDate, endDate: endDate, key: "selection"}
            this.setState({
                //typeGraph: prevTypeGraph,
                period: "c",
                typePeriod: 3,
                namePeriod: 'Rango: ' + startDate.substring(0, 10) + ' a ' + endDate.substring(0, 10),
                statePeriod: statePeriod,
                isStatePeriod: true,
                periodEl: null,
                isRefresh: false,
                begin: startDate,
                end: endDate, 
            });
        }
        //this.getDataFromAPI();
    }


    handleChangePage = (e, page)=>{
        this.setState({
            page : page
        })
    }

    render() {
        
        const { classes, location } = this.props;
        const {listMonitores, nodes, steps, objetive, dateMoment, dateBefore, isLoad, extendEl, nameNodo, node, limit,
            errors, indexError, limit2, begin, end, isLoadButton, modal, 
            statePeriod, namePeriodPorlet, typeGraph, typePeriod, isOneHour, periodEl, periodical, period, namePeriod, page, pages, service} = this.state;
        const showExtendEl = Boolean(extendEl);
        const showPeriodEl = Boolean(periodEl);
        if (isLoad===true) {
            return(
                <div>
    
                    <Typography
                        variant="caption"
                    >
                        <CircularProgress
                        variant="indeterminate"

                        size={12}
                        thickness={3}
                        
                    />
                        Cargando Información...
                    </Typography>
                </div>
            )
        }else{
            //console.log('render base', classes)
            return (
                <Portlet className={classes.backGrey}>
                    <Grid
                        item
                        xs={12}
                        md={12}
                        xl={12}
                        style={{textAlign:'right'}}
                    >
                        <IconButton key="close" aria-label="close" style={{color:"white"}} onClick={this.handleClose}><CloseIcon/></IconButton>
                    </Grid>
                    <PortletHeader>
                        <PortletToolbar style={{width:"100%"}}>
                            <Grid
                                container
                            >
                                <Grid
                                    item
                                    xs={12}
                                    md={12}
                                    xl={12}
                                >
                                    <Typography variant="h3" className={classes.textWhite}>Screenshots</Typography>
                                    <Typography variant="h6" className={classes.textWhite}>{namePeriod}</Typography>
                                </Grid>
                                
                                
                                <Grid
                                    style={{textAlign:"left"}}
                                    item
                                    xs={4}
                                    md={4}
                                    xl={4}
                                >
                                    <Button
                                        color="primary"
                                        variant="text"
                                        onClick={this.handleShowExtend}
                                    >
                                        {nameNodo} <ArrowDropDownIcon />
                                    </Button>
                                    
                                    <Popover
                                        anchorEl={extendEl}
                                        anchorOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 'center'
                                          }}
                                          transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'center'
                                          }}
                                        onClose={this.handleCloseExtend}
                                        open={showExtendEl}
                                        >
                                        <div className="row1">
                                            <List component="div">
                                                {Object.values(location.state.fromObjective.Nodos).map(i => (
                                                    <ListItem
                                                        key={i.id_nodo}
                                                        className={classes.listItem}
                                                        component="div"
                                                    >
                                                        <Button id={i.id_nodo} name={i.nodo} onClick={(event) => this.handleNextNodeClick(event)}>{i.nodo}</Button> 
                                                    </ListItem>))}
                                            </List>
                                        </div> 
                                    </Popover> 
                                </Grid>
                                <Grid
                                    
                                    item
                                    xs={8}
                                    md={8}
                                    xl={8}
                                >
                                   <Button  style={{fontSize:'14px',float:'right', color:'white'}} onClick={this.handleShowPeriod}>
                                        {namePeriodPorlet[typePeriod]}<ArrowDropDownIcon />
                                    </Button>
                                    <Popover
                                        anchorEl={periodEl}
                                        anchorOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 'center'
                                        }}
                                        onClose={this.handleClosePeriod}
                                        open={showPeriodEl}
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'center'
                                        }}>
                                            <Period onClick={this.handlePeriodClick} range={statePeriod} period={period} periodical={periodical} typeGraph={typeGraph} isOneHour={isOneHour}/>
                                    </Popover>
                                </Grid>
                            </Grid>
                        </PortletToolbar>
                    </PortletHeader>
                    <ScreenshotElement monitors={listMonitores} nodes={nodes} node={node} objective={objetive} steps={steps} 
                        dateBegin={begin} dateFinal={end} callbackFromParent={this.myCallback} service={service}
                    />
                </Portlet>
            )
        
        }

        
    }
}


export default
    compose(withRouter, withStyles(styles))(ScreenshotsRebuild);